import React from "react";
import { Nav } from "./Header.elements";
import { logOut } from "../../firebase/firebase-core";

export default function Header({ isUserAuth = false }) {
  const handleOnExit = async () => {
    logOut()
      .then(() => {
        // Sign-out successful
        console.log("User signed out");
      })
      .catch((error) => {
        // An error occurred
        console.error("Error signing out:", error);
      });
  };

  return (
    <Nav>
      <img src="icon.png" width={64} height={72} />
      <h1>Basta Trânsito 1.0.2 - (última atualização 8/1/2025 - 10:00) </h1>

      {isUserAuth && (
        <div style={{ width: "50%", textAlign: "end" }}>
          <a href="#" onClick={handleOnExit}>
            Sair
          </a>
        </div>
      )}
    </Nav>
  );
}
